import React from 'react';
import PropTypes from 'prop-types';

import { AImagePlaceholder } from '../atoms';
import uploadImage from '../../helpers/uploadImage';

export default class OFeaturedImageUpload extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			imageUploading: false,
		};

		this.bindHandles();
	}

	bindHandles() {
		this.handleFileUpload = this.handleFileUpload.bind(this);
		this.handleKeyUp = this.handleKeyUp.bind(this);
		this.openFileDialog = this.openFileDialog.bind(this);
	}

	handleFileUpload(event) {
		const file = event.target.files;

		if (this.props.onUpload) {
			this.setState({ imageUploading: true });
			uploadImage(file[0])
				.then((res) => {
					this.props.onUpload({
						imageFile: file[0],
						url: res.data.url,
						uuid: res.data.uuid,
					});
					this.setState({ imageUploading: false });
				})
				.catch((err) => {
					this.setState({ imageUploading: false });
				});
		}
	}
	openFileDialog() {
		document.getElementById(this.props.id).click();
	}

	handleKeyUp(event) {
		if(event.keyCode === 13) {
			this.openFileDialog();
		}
	}

	render() {
		let errMessage;
		let placement = <AImagePlaceholder loading={this.state.imageUploading} />;

		if (this.props.imageURL && !this.state.imageUploading) {
			placement = (
				<figure className="image-preview">
					<img src={this.props.imageURL} alt="" />
				</figure>
			);
		}

		if (this.props.errorMessage) {
			errMessage = <p className="error">Error</p>;
		}

		return (
			<section className={`o-cms-file-upload ${this.props.className}`}>
				<h2>{this.props.title}</h2>
				{errMessage}
				<label
					htmlFor={this.props.id}
					className="file-upload"
				>
					{placement}
					<input
						id={this.props.id}
						type="file"
						accept="image/jpeg, image/png"
						onChange={this.handleFileUpload}
					/>

					<label
						className="a-button a-button--default upload-button"
						onClick={this.openFileDialog}
						onKeyUp={this.handleKeyUp}
						role="button" // eslint-disable-line
						tabIndex="0"
					>
						Kies een bestand
					</label>
				</label>
			</section>
		);
	}
}

OFeaturedImageUpload.propTypes = {
	id: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	imageURL: PropTypes.string,
	errorMessage: PropTypes.string,
	className: PropTypes.string,
	onUpload: PropTypes.func,
};

OFeaturedImageUpload.defaultProps = {
	onUpload: undefined,
	imageURL: undefined,
	errorMessage: '',
	className: '',
};



// WEBPACK FOOTER //
// ./src/components/organisme/_organisme.featured-image-upload.js